import dayjs from 'dayjs'

export const diffFromNow = (value: string) => {
  const now = dayjs(new Date())
  const restDay = dayjs(`${value} 23:59:59`).diff(now, 'd')
  const restHour = dayjs(`${value} 23:59:59`).diff(now, 'h') - restDay * 24
  const restMinute =
    dayjs(`${value} 23:59:59`).diff(now, 'm') -
    restDay * 24 * 60 -
    restHour * 60

  return !restDay && !restHour && restMinute < 1
    ? '即将结束'
    : `${restDay ? restDay + '天' : ''}${
        restHour ? restHour + '时' : ''
      }${restMinute}分`
}
